"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TextArea = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TextArea_module_scss_1 = __importDefault(require("./TextArea.module.scss"));
/**
 * @deprecated Please use the same component from `@kaizen/components`
 */
var TextArea = function (_a) {
    var propsTextAreaRef = _a.textAreaRef, _b = _a.status, status = _b === void 0 ? "default" : _b, _c = _a.autogrow, autogrow = _c === void 0 ? false : _c, _d = _a.reversed, reversed = _d === void 0 ? false : _d, automationId = _a.automationId, _e = _a.rows, rows = _e === void 0 ? 3 : _e, defaultValue = _a.defaultValue, value = _a.value, disabled = _a.disabled, propsOnChange = _a.onChange, restProps = __rest(_a, ["textAreaRef", "status", "autogrow", "reversed", "automationId", "rows", "defaultValue", "value", "disabled", "onChange"]);
    var _f = (0, react_1.useState)("auto"), textAreaHeight = _f[0], setTextAreaHeight = _f[1];
    var _g = (0, react_1.useState)("auto"), parentHeight = _g[0], setParentHeight = _g[1];
    var _h = (0, react_1.useState)(autogrow ? defaultValue : undefined), internalValue = _h[0], setInternalValue = _h[1];
    // ^ holds an internal state of the value so that autogrow can still work with uncontrolled textareas
    // essentially forces the textarea into an (interally) controlled mode if autogrow is true
    var textAreaRef = propsTextAreaRef || (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!autogrow)
            return;
        var scrollHeight = textAreaRef.current.scrollHeight;
        if (scrollHeight < 1)
            return;
        var borderWidth = textAreaRef.current
            ? parseInt(getComputedStyle(textAreaRef.current).borderTopWidth, 10)
            : 0;
        var newHeight = scrollHeight + borderWidth * 2;
        setParentHeight("".concat(newHeight, "px"));
        setTextAreaHeight("".concat(newHeight, "px"));
    }, [internalValue]);
    var onChange = !autogrow
        ? undefined
        : function (event) {
            setTextAreaHeight("auto");
            // ^ this is required to avoid the textarea height from building up indefinitely
            // see https://medium.com/@lucasalgus/creating-a-custom-auto-resize-textarea-component-for-your-react-web-application-6959c0ad68bc#2dee
            setInternalValue(event.target.value);
            if (propsOnChange) {
                propsOnChange(event);
            }
        };
    var getWrapperStyle = function () {
        return autogrow ? { minHeight: parentHeight } : undefined;
    };
    var getTextAreaStyle = function () {
        return autogrow ? { height: textAreaHeight } : undefined;
    };
    var controlledValue = value || internalValue;
    return (react_1["default"].createElement("div", { className: TextArea_module_scss_1["default"].wrapper, style: getWrapperStyle() },
        react_1["default"].createElement("textarea", __assign({ className: (0, classnames_1["default"])(TextArea_module_scss_1["default"].textarea, TextArea_module_scss_1["default"][status], reversed ? TextArea_module_scss_1["default"].reversed : TextArea_module_scss_1["default"]["default"], disabled && TextArea_module_scss_1["default"].disabled), rows: rows, onChange: onChange || propsOnChange, "data-automation-id": automationId, value: controlledValue, defaultValue: controlledValue ? undefined : defaultValue, 
            // ^ React throws a warning if you specify both a value and a defaultValue
            ref: textAreaRef, style: getTextAreaStyle(), disabled: disabled }, restProps)),
        react_1["default"].createElement("div", { className: TextArea_module_scss_1["default"].focusRing })));
};
exports.TextArea = TextArea;
exports.TextArea.displayName = "TextArea";
//# sourceMappingURL=TextArea.js.map